const ClaudV2 = ({
  setCurrentView
}: {
  setCurrentView: (
    val: 'setup' | 'interview' | 'complete' | 'home' | 'written'
  ) => void;
}) => {
  return (
    <div className='min-h-screen bg-gray-100'>
      <main className='mx-auto max-w-7xl p-6'>
        <div className='text-center'>
          <div className='mb-8 text-5xl font-bold'>
            🎯
            <span className='bg-gradient-to-r from-[#667eea] to-[#764ba2] bg-clip-text font-sans text-[#2c3e50] text-transparent'>
              {' '}
              FreshersToday
            </span>
          </div>
          <h2 className='mb-5 inline-block border-b-4 border-[#667eea] pb-3 text-3xl font-bold text-[#2c3e50]'>
            Your Gateway to IT Career Success
          </h2>
          <p className='mb-10 text-lg text-[#666]'>
            Master technical interviews with our comprehensive preparation
            platform
          </p>
          <div className='mt-10 grid grid-cols-1 gap-8 md:grid-cols-2'>
            <div className='rounded-3xl bg-gradient-to-br from-[#667eea] to-[#764ba2] p-8 text-center text-white shadow-lg'>
              <span className='mb-4 block text-6xl'>📝</span>
              <h3 className='mb-4 text-2xl font-semibold'>
                Company Test Module
              </h3>
              <p className='mb-6 text-lg'>
                Practice MCQs across Reasoning, Aptitude, Computer Science, and
                Coding sections
              </p>
              <button
                className='rounded-full border-2 border-white bg-white px-8 py-3 text-lg font-semibold text-[#667eea] transition-all duration-300 hover:bg-[#667eea] hover:text-white hover:shadow-lg'
                onClick={() => setCurrentView('written')}
              >
                Start Company Test
              </button>
            </div>
            <div className='rounded-3xl bg-gradient-to-br from-[#84fab0] to-[#8fd3f4] p-8 text-center text-[#2c3e50] shadow-lg'>
              <span className='mb-4 block text-6xl'>🎤</span>
              <h3 className='mb-4 text-2xl font-semibold'>Interview Module</h3>
              <p className='mb-6 text-lg'>
                Practice speaking interviews with AI-powered feedback and
                evaluation
              </p>
              <button
                className='rounded-full bg-gradient-to-r from-[#667eea] to-[#764ba2] px-8 py-3 text-lg font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-xl'
                onClick={() => setCurrentView('setup')}
              >
                Start Interview
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ClaudV2;
